import { isEqual } from 'lodash';
import BaseDropdown from '../../base/dropdowns/dropdown';

import '../../base/dropdowns/dropdown.scss';

class RetailerOverviewDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'options';
    this.dropdownName = this.props.type;
    this.identifierField = 'value';
    this.hasSearch = false;

    this.state = {
      options: this.props.items,
      opened: false,
      focusIndex: null,
      label: this.getLabel(this.props.items),
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.items, this.props.items)) {
      const options = this.getSelectedOptions(this.props.items);
      this.setState({
        options,
        label: this.getLabel(this.props.items),
      });
    }
  }

  getLabel(options) {
    const selected = options.reduce((acc, option) => {
      return option.selected
        ? [...acc, this.props.type === 'retailers' ? option.value : option.label]
        : acc;
    }, []);

    const oneselected = selected.length === 1;
    const allSelected = selected.length === 0 || selected.length === options.length;

    switch (this.props.type) {
      case 'retailers':
        return `${allSelected ? 'All' : selected.join(', ')} Partners`;
      case 'payment-models':
        return oneselected
          ? selected[0]
          : `${allSelected ? 'All' : selected.length} Payment Models`;
      case 'availability':
        return oneselected ? selected[0] : 'Availability';
      default:
    }
  }

  getSelectedOptions(options) {
    // If no options selected, select all options instead
    const exceptions = ['availability'];
    if (!options.find(option => option.selected) && !exceptions.includes(this.props.type)) {
      return options.reduce((acc, option) => [...acc, { ...option, selected: true }], []);
    }
    return options;
  }

  update() {
    this.props.updateOptions(this.getSelectedOptions(this.state.options));
  }
}

export default RetailerOverviewDropdown;
